import TextImageSharedComponent from "@components/severalbrands/homePage/firstSection/textImageSharedComponent";
import style from "./style.module.scss";
const simplifyingComplexDecisions = {
    img: "/severalbrands/assets/images/simplifyingComplexDecisions.webp",
    mainTitle: "High-Intent Lead Generation Company",
    secondTitle: "Pay for performance, not promises",
    paragraphs: [
        "We connect businesses with high-intent leads across legal, auto, B2B, B2C, and home services verticals. Our reach is nationwide, backed by local market expertise across every industry we serve.",
        "Pricing is performance-based and prepaid, so you pay for the leads you receive, not a flat retainer. And because we work across so many verticals, our team brings deep, industry-specific expertise to every partnership, not a one-size-fits-all approach to lead generation.",
    ],
    mainH1Element: true,
};
const deliveringOurPromises = {
    img: "/severalbrands/assets/images/deliveringOnOurPromises.webp",
    mainTitle: "Delivering on Our Promises",
    paragraphs: [
        "We generate real-time leads in-house through market research and performance marketing, not recycled data pulled from a third party. That means the prospects we send are current, relevant, and matched to what you're actually looking for.",
        "We built our process around consistent delivery, not a one-time sale. Pricing is performance-based and prepaid, and we work at the pace that makes sense for each partnership, checking in regularly to see how the leads we're sending are actually performing on your end.",
    ],
    imgToLeft: true,
    showAnimation: true,
};
export default function FirstSection() {
    return (
        <section className={style["bgStyle"]}>
            <div>
                <div
                    className={`lg:py-28 py-16 3xl:py-16  ${style["hero-section"]}`}
                >
                    <TextImageSharedComponent
                        info={simplifyingComplexDecisions}
                    />
                </div>
                <div className="3xl:pt-5 3xl:pb-56 lg:pb-32 pb-32 ">
                    <TextImageSharedComponent info={deliveringOurPromises} />
                </div>
            </div>
        </section>
    );
}
